import React, { useState, useEffect, useMemo, useRef } from "react";
import { TemplateService, TemplateTypeEnum } from "@propertelligent/client-api";
import { infiniteScrollHook } from "../../../hooks/infiniteScrollHook";
import EmptyState from "../../../newComponents/emptystate";
import AddButtonWithArrow from "../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { GetImages } from "../../../utils/GetImages";
import ActionMenu from "../../../newComponents/actionMenus/action-menu";
import { useNavigate } from "react-router";
import CommonTwoPaneView from "../component/CommonTwoPaneView/CommonTwoPaneView";
import { TextCss } from "../../GlobalCss/TextCss";
import useInfiniteScroll from "react-infinite-scroll-hook";
import SimpleSpinner from "../../loader";
import apiHelper from "../../../utils/apiHelper";
import { ConfirmationPopup } from "../../../newComponents/confirmation-popup/confirmation-popup-demo";
import NotesIcon from "../../../assets/notesFileIcon.svg";
import { usePermissions } from "../../../hooks/usePermissions";
import { PermissionGuard } from "../../../newComponents/PermissionGuard";
import NoAccess from "../../../pages/NoAccess";
import { AccessLevelEnum } from "@propertelligent/client-api";
import TruncatedDescriptionCell from "../../../newComponents/common/TruncatedDescriptionCell";

const TempleteView = () => {
   const scrollRef = useRef(null);
   const [deleteId, setDeleteId] = useState(null);
  const [activeTab, setActiveTab] = useState(
    () => localStorage.getItem("TemplatesActiveTab") || "LeaseApplication"
  );

  useEffect(() => {
    localStorage.setItem("TemplatesActiveTab", activeTab);
  }, [activeTab]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
    const [LeasecurrentSortDirection, setLeaseCurrentSortDirection] = useState("asc");
    const [LeaseAggcurrentSortDirection, setLeaseAggCurrentSortDirection] = useState("asc");
  const navigate = useNavigate();

  // For Empty State (per tab -- a tab having templates must not hide the other tab's own empty-state Add button)
  const [hasAnyTemplatesByTab, setHasAnyTemplatesByTab] = useState<Record<"LeaseApplication" | "LeaseAgreement", boolean>>({
    LeaseApplication: false,
    LeaseAgreement: false,
  });

  const check = usePermissions();
  const canWrite = check.canWrite("Templates");

  const leaseAppHook = infiniteScrollHook({
    httpFetchDataFn: TemplateService.getApiTemplateOrganizationlist,
    FullyQualifiedFilters: `templateTypeId == ${TemplateTypeEnum.LeaseApplication}`,
    FullyQualifiedSorts: `name ${LeasecurrentSortDirection}`,
    pageSize: 10,
  });

  const {
    loading: loadingLeaseApp,
    rows: rowsLeaseApp,
    rowCount: leaseAppRowCount,
     hasMore: hasMoreLeaseApp,
     currentPage: pageLeaseApp,
    fetchData: fetchLeaseApp,
    handleSort: handleSortLease,
    currentSortDirection: sortLease,
  } = leaseAppHook;
useMemo(()=>{setLeaseCurrentSortDirection(sortLease)},[sortLease])


const loadMoreLeaseApp = () => {
    if (!loadingLeaseApp && hasMoreLeaseApp) {
      fetchLeaseApp(pageLeaseApp + 1);
    }
  };

  const [leaseAppRef] = useInfiniteScroll({
    loading: loadingLeaseApp,
    hasNextPage: hasMoreLeaseApp,
    onLoadMore: loadMoreLeaseApp,
    disabled: !hasMoreLeaseApp,
    rootMargin: "0px 0px 00px 0px",
  });

  const leaseAgreementHook = infiniteScrollHook({
    httpFetchDataFn: TemplateService.getApiTemplateOrganizationlist,
    FullyQualifiedFilters: `templateTypeId == ${TemplateTypeEnum.LeaseAgreement}`,
    FullyQualifiedSorts: `name ${LeaseAggcurrentSortDirection}`,
    pageSize: 10,
  });

  const {
    loading: loadingLeaseAgreement,
    rows: rowsLeaseAgreement,
    rowCount: leaseAggRowCount,
     hasMore: hasMoreLeaseAgreement,
     currentPage: pageLeaseAgreement,
    fetchData: fetchLeaseAgreement,
    handleSort: handleSortAgg,
    currentSortDirection: sortAgg,
  } = leaseAgreementHook;
useMemo(()=>{setLeaseAggCurrentSortDirection(sortAgg)},[sortAgg])

  const loadMoreLeaseAgreement = () => {
    if (!loadingLeaseAgreement && hasMoreLeaseAgreement) {
      fetchLeaseAgreement(pageLeaseAgreement + 1);
    }
  };

  const [leaseAggRef] = useInfiniteScroll({
    loading: loadingLeaseAgreement,
    hasNextPage: hasMoreLeaseAgreement,
    onLoadMore: loadMoreLeaseAgreement,
    disabled: !hasMoreLeaseAgreement,
    // rootMargin: "0px 0px 300px 0px",
  
    
  });

  const handleAddTemplate = (path) => {
    navigate(path);
  };

  useEffect(() => {
    setHasAnyTemplatesByTab({
      LeaseApplication: leaseAppRowCount > 0,
      LeaseAgreement: leaseAggRowCount > 0,
    });
  }, [leaseAppRowCount, leaseAggRowCount]);

  const renderEmptyState = (label, tabKey: "LeaseApplication" | "LeaseAgreement") => {
    const hasAnyForTab = hasAnyTemplatesByTab[tabKey];
    return (
      <EmptyState
        heading={hasAnyForTab ? `No ${label} Templates Found` : `Add Your First ${label} Template`}
        actionNode={
          !hasAnyForTab && canWrite ? (
            <AddButtonWithArrow
              onClick={() =>
                navigate(activeTab === "LeaseApplication" ? "create" : "create-lease-agreement")}
              buttonname="Add Template"
            />
          ) : null
        }
        icon={NotesIcon}
        isBorder={false}
      />
    );
  };
 const handleDelete = (id) => {
    if (!id) return Promise.resolve();

    return apiHelper(TemplateService.deleteApiTemplate, {
      title: "Template Deleted",
      successMessage: "Template deleted successfully",
      failureMessage: "Unable to Delete Template",
      showNotification: true,
    }, Number(id)).then((res) => {
      if(res.data.success){
      if (activeTab === "LeaseApplication") {
    fetchLeaseApp(1);
  } else {
    fetchLeaseAgreement(1);
  }}
      // navigate("/organization/templates");
    }).catch((err) => { });
  };
  


  const renderList = (rows, label, pathBase, loading, hasMore, sentryRef, tabKey: "LeaseApplication" | "LeaseAgreement") => {
    if ((!rows || rows.length === 0) && !loading) return renderEmptyState(label, tabKey);

    if ((!rows || rows.length === 0) && loading) {
      return (
        <div className="d-flex justify-content-center align-items-center h-100 w-100" style={{ minHeight: '300px' }}>
             <SimpleSpinner myClassName="Icon50" />
        </div>
      );
    }

    return (
      <div className="template-list">
        {
         rows.map((item) => (
          <div key={item.id}className="template-item">
            <div className="w-100" onClick={(e) => {
              // The View more popover is portaled outside this row but its clicks still bubble here.
              if (!e.currentTarget.contains(e.target as Node)) return;
              navigate(`${pathBase}/${item.id}`, { state: { fromTemplateTab: activeTab } });
            }}>
              <div className={TextCss.black.heading_700_16} style={{ overflowWrap: "anywhere" }}>{item.name}</div>
              <div className="template-item-description">
                {item.description ? (
                  <TruncatedDescriptionCell description={item.description} maxChars={100} noWrap={false} />
                ) : (
                  "Description for Template"
                )}
              </div>
            </div>

            {canWrite && (
              <ActionMenu
                menuItems={[
                  {
                    label: "Edit",
                    icon: GetImages.BlackPencil,
                    action: () => navigate(
                      activeTab === "LeaseApplication"
                        ? `edit/${item.id}`
                        : `lease-agreement/${item.id}`,
                      { state: { fromTemplateTab: activeTab } }
                    ),
                  },
                  { isDivider: true },
                  { label: "Delete", icon: GetImages.BlackDelete, action: () => {setDeleteId(item.id);setShowConfirmation(true);} },
                ]}
                trigger={
                  <button className="action-button">
                    <img src={GetImages.dropdownIcon} width={20} height={20} alt="More" className="iconStyleWithWhiteFilter" />
                  </button>
                }
              />
            )}
          </div>
        ))}
         {(loading || hasMore) && (
        <div ref={sentryRef} className="loading-trigger">
          {loading && (
            <SimpleSpinner
              myClassName={rows.length === 0 ? "Icon50" : "Icon40"}
            />
          )}
        </div>
      )}
      </div>
    );
  };

   const tabConfig = {
    LeaseApplication: {
      rows: rowsLeaseApp,
      sort: sortLease,
      onSort: handleSortLease,
      loading:loadingLeaseApp,
      content: () =>
        renderList(
          rowsLeaseApp,
          "Lease Application",
          "edit",
          loadingLeaseApp,
          hasMoreLeaseApp,
          leaseAppRef,
          "LeaseApplication"
        ),
    },
    LeaseAgreement: {
      rows: rowsLeaseAgreement,
      sort: sortAgg,
      onSort: handleSortAgg,
      loading:loadingLeaseAgreement,
      content: () =>
        renderList(
          rowsLeaseAgreement,
          "Lease Agreement",
          "lease-agreement",
          loadingLeaseAgreement,
          hasMoreLeaseAgreement,
          leaseAggRef,
          "LeaseAgreement"
        ),
    },
  };

  const active = tabConfig[activeTab];


const handleDeleteAction = async () => {
  if (isDeleting) return;

  setIsDeleting(true);
  try {
    await handleDelete(deleteId);   // NOW this waits for delete to finish

    setShowConfirmation(false);
    setDeleteId(null);


  } catch (error) {
    console.error(error);
  } finally {
    setIsDeleting(false);
  }
};
  return (
    <PermissionGuard permission="Templates" level={AccessLevelEnum.ReadOnly} fallback={<NoAccess />}>
      <>
       <CommonTwoPaneView
      title="Templates"
      
      sidebarTabs={[
        { key: "LeaseApplication", label: "Lease Application", count: leaseAppRowCount },
        { key: "LeaseAgreement", label: "Lease Agreement", count: leaseAggRowCount },
      ]}
      handleSort={active.onSort}
      currentSortDirection={active.sort}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      addButtonLabel="Add Template"
      onAdd={canWrite ? () =>
        navigate(activeTab === "LeaseApplication" ? "create" : "create-lease-agreement")
      : undefined}
      loadingCombined={active.loading}
      hasAnyReports={hasAnyTemplatesByTab.LeaseApplication || hasAnyTemplatesByTab.LeaseAgreement}
      renderListForTab={() => active.content()}
    />

  <ConfirmationPopup
  isOpen={showConfirmation}
  title="Delete Template"
  message="Do you want to delete this Template?"
  primaryButtonLabel="Delete"
  secondaryButtonLabel="Cancel"
  onPrimaryAction={handleDeleteAction}
  onSecondaryAction={() => {
      setShowConfirmation(false);
      setDeleteId(null);
    }}
  onClose={() => {
      setShowConfirmation(false);
      setDeleteId(null);
    }}
  isPrimaryDestructive={true}
  isLoading={isDeleting}
  loadingLabel="Deleting..."
/>
          </>
    </PermissionGuard>
  );
};

export default TempleteView;


